import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // 120 seconds timeout for AI operations
});

// Refresh token promise'i sakla (race condition önleme)
let refreshTokenPromise: Promise<any> | null = null;

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // FormData için Content-Type'ı kaldır (axios otomatik ayarlar)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Impersonation modunda token expire olursa admin oturumuna geri dön
      const adminToken = sessionStorage.getItem('admin_accessToken');
      if (adminToken) {
        const adminRefreshToken = sessionStorage.getItem('admin_refreshToken');
        const adminUser = sessionStorage.getItem('admin_user');
        if (adminToken) localStorage.setItem('accessToken', adminToken);
        if (adminRefreshToken) localStorage.setItem('refreshToken', adminRefreshToken);
        if (adminUser) localStorage.setItem('user', adminUser);
        sessionStorage.removeItem('admin_accessToken');
        sessionStorage.removeItem('admin_refreshToken');
        sessionStorage.removeItem('admin_user');
        window.location.href = '/tickets';
        return Promise.reject(error);
      }

      try {
        // Eğer zaten bir refresh işlemi devam ediyorsa, onu bekle
        if (!refreshTokenPromise) {
          const refreshToken = localStorage.getItem('refreshToken');
          if (!refreshToken) {
            throw new Error('No refresh token available');
          }

          refreshTokenPromise = axios.post(`${API_BASE_URL}/auth/refresh`, {
            refreshToken,
          }).finally(() => {
            refreshTokenPromise = null;
          });
        }

        const response = await refreshTokenPromise;

        if (response?.data?.success) {
          const { accessToken, refreshToken: newRefreshToken } = response.data.data;
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', newRefreshToken);

          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError: any) {
        refreshTokenPromise = null;

        // Nur ausloggen, wenn der Refresh wirklich abgelehnt wurde (401/403) oder
        // gar kein Refresh-Token vorhanden ist. Bei 429 (Rate-Limit), 5xx oder
        // Netzwerkfehlern die Session behalten — sonst fliegt der User bei einem
        // kurzen Serverhänger komplett raus.
        const status = refreshError?.response?.status;
        const hasRefreshToken = !!localStorage.getItem('refreshToken');
        const sessionRejected = status === 401 || status === 403 || !hasRefreshToken;

        if (!sessionRejected) {
          return Promise.reject(refreshError);
        }

        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;